export const config = {
  api: {
    baseUrl: process.env.REACT_APP_API_URL || 'https://keolis.it-xpert.be',
  },
  cognito: {
    region: process.env.REACT_APP_AWS_REGION || 'eu-west-3',
    userPoolId: process.env.REACT_APP_USER_POOL_ID || 'eu-west-3_UrKyfGXJe',
    userPoolWebClientId: process.env.REACT_APP_CLIENT_ID || '5jlvkm4q3caqmlcnbrfact0o9g',
  },
};
